<template>
	<DataTable
		:value="currentDocumentationData"
		columnResizeMode="fit"
		responsiveLayout="scroll"
		:scrollable="true"
		scrollHeight="flex"
		:rowHover="true"
	>
		<Column field="operator" header="" style="min-width: 8rem;" />
		<Column field="comparator" :header="$t('Squeeze.General.Comparator')" headerClass="header-center" style="text-align: center;"></Column>
		<Column field="example" :header="$t('Squeeze.General.Example')" style="min-width: 8rem; max-width: 8rem;">
			<template #body="slotProps">
				{{ slotProps.data[currentFilterFieldType.toLowerCase()] }}
			</template>
		</Column>
	</DataTable>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {useI18n} from "vue-i18n";

interface FieldType {
	operator: string;
	comparator: string;
	text: string;
	date: string;
	amount: string;
}

export default defineComponent({
	name: "HelpFunctionalityList",
	components: {
		DataTable,
		Column,
	},
	props: {
		currentFilterFieldType: {
			type: String,
			required: true,
		},
	},
	setup() {
		const {t} = useI18n();

		/**
		 * Current documentation data to get all functionalities
		 * Handling of (filter) field types
		 */
		const currentDocumentationData = ref<FieldType[]>([
			{
				operator: t('Squeeze.Operators.Equals'),
				comparator: "=",
				text: "=GmbH",
				date: "=31.12.2023",
				amount: "=1012,99",
			},
			{
				operator: t('Squeeze.Operators.NotEqual'),
				comparator: "!=",
				text: "!=GmbH",
				date: "!=31.12.2023",
				amount: "!=1012.99",
			},
			{
				operator: t('Squeeze.Operators.GreaterThan'),
				comparator: ">",
				text: ">1012.99",
				date: ">31.12.2023",
				amount: ">1012.99",
			},
			{
				operator: t('Squeeze.Operators.LowerThan'),
				comparator: "<",
				text: "<1012.99",
				date: "<31.12.2023",
				amount: "<1012.99",
			},
			{
				operator: t('Squeeze.Operators.GreaterOrEqual'),
				comparator: ">=",
				text: ">=1012.99",
				date: ">=31.12.2023",
				amount: ">=1012.99",
			},
			{
				operator: t('Squeeze.Operators.LowerOrEqual'),
				comparator: "<=",
				text: "<=1012.99",
				date: "<=31.12.2023",
				amount: "<=1012.99",
			},
			{
				operator: t('Squeeze.Operators.In'),
				comparator: "<<",
				text: "<< GmbH, AG",
				date: "-",
				amount: "-",
			},
			{
				operator: t('Squeeze.Operators.NotIn'),
				comparator: "!<<",
				text: "!<< GmbH, AG",
				date: "-",
				amount: "-",
			},
			{
				operator: t('Squeeze.Operators.Empty'),
				comparator: "--",
				text: "--",
				date: "--",
				amount: "-",
			},
			{
				operator: t('Squeeze.Operators.NotEmpty'),
				comparator: "!--",
				text: "!--",
				date: "!--",
				amount: "-",
			},
			{
				operator: t('Squeeze.Operators.StartsWith'),
				comparator: "abc*",
				text: "GmbH*",
				date: "-",
				amount: "-",
			},
			/*{
					operator: t('Squeeze.Operators.NotStartsWith'),
					comparator: "-",
					text: "-",
					date: "-",
					amount: "-",
				},*/
			{
				operator: t('Squeeze.Operators.EndsWith'),
				comparator: "*abc",
				text: "*GmbH",
				date: "-",
				amount: "-",
			},
			/*{
					operator: t('Squeeze.Operators.NotEndsWith'),
					comparator: "-",
					text: "-",
					date: "-",
					amount: "-",
				},*/
			{
				operator: t('Squeeze.Operators.Contains'),
				comparator: "*abc*",
				text: "*GmbH*",
				date: "-",
				amount: "-",
			},
			/*{
				operator: t('Squeeze.Operators.NotContains'),
				comparator: "-",
				text: "-",
				date: "-",
				amount: "-",
			},*/]);

		return {
			t,
			currentDocumentationData,
		}
	},
})
</script>

<style scoped>

::v-deep(.header-center div.p-column-header-content) {
	justify-content: center;
}

</style>
